<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'App',
  components: { },
  data() {
    return {
      
    };
  },
  mounted () {
    document.body.addEventListener('touchstart', function (){})
  }
}
</script>
<style>
  body{
    padding: 0;
    margin: 0;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #303133;
    user-select: none;
  }
  .black{
    color: #303133;
  }
  .normal {
    color: #606266;
  }
  .gray{
    color: #909399;
  }
  .light{
    color: #C0C4CC;
  }
  .border{
    border: 1px solid #F2F6FC;
  }
  .my-calendar .m-calendar .m-toolbar{
    background: #fff;
  }
  .my-calendar .m-calendar .m-week-header{
    background: #fff;
  }
  .my-calendar .m-calendar .m-months-container .m-months-wrapper .m-months .m-row:before{
    background-color: #F2F6FC;
  }
  .my-calendar .m-calendar .m-toolbar .m-month-selector .m-next-btn, .my-calendar .m-calendar .m-toolbar .m-year-selector .m-next-btn{
    background-image: url('./assets/next-btn.png')
  }
  .my-calendar .m-calendar .m-toolbar .m-month-selector .m-prev-btn, .my-calendar .m-calendar .m-toolbar .m-year-selector .m-prev-btn{
    background-image: url('./assets/next-btn.png');
    transform: rotate(180deg);
  }
</style>
